export default __webpack_public_path__ + "static/app-features-5--mobile-38521b91add69b07d6f2b9852b330add.png";